<!-- Only show footer when not on login or signup pages -->
@if (shouldShowFooter()) {
  <footer class="absolute inset-x-0 bottom-0 h-8">
    <p-toolbar>
      <ng-template #start>
        <div class="flex items-center gap-2">
          @for (link of links; track $index) {
            @if (link.routerLink) {
              <a [routerLink]="link.routerLink">
                <span>{{link.label}}</span>
              </a>
            } @else if (link.url) {
              <a [href]="link.url" target="_blank">
                <span>{{link.label}}</span>
              </a>
            }
          }
        </div>
      </ng-template>
      <ng-template #end>
        <div class="flex items-center gap-2">
          @for (link of endLinks; track $index) {
            @if (link.routerLink) {
              <a [routerLink]="link.routerLink">
                <span>{{link.label}}</span>
              </a>
            } @else if (link.url) {
              <a [href]="link.url" target="_blank">
                <span>{{link.label}}</span>
              </a>
            }
          }
        </div>
      </ng-template>
    </p-toolbar>
  </footer>
}
